<script setup>
import { useReminder } from '@/composables/useReminder'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Reminder',
  },
})

const status = ref('due')
const { reminders, loading, fetchReminders } = useReminder()

const load = () => fetchReminders({ status: status.value === 'all' ? null : status.value })

onMounted(load)
watch(status, load)

const headers = [
  { title: 'Jenis Objek', key: 'remindable_type' },
  { title: 'ID', key: 'remindable_id', width: 90 },
  { title: 'Jatuh Tempo', key: 'due_date', width: 140 },
  { title: 'Ingatkan Sebelum', key: 'remind_before_days', width: 150 },
  { title: 'Status', key: 'status', width: 120 },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Reminder
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Rekap objek dengan tanggal kedaluwarsa lintas modul (§10.5)
            </p>
          </div>
          <VBtnToggle
            v-model="status"
            density="compact"
            color="primary"
            mandatory
          >
            <VBtn value="due">
              Jatuh Tempo
            </VBtn>
            <VBtn value="upcoming">
              Akan Datang
            </VBtn>
            <VBtn value="all">
              Semua
            </VBtn>
          </VBtnToggle>
        </div>
      </VCol>
    </VRow>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="reminders"
        :loading="loading"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #item.remindable_type="{ item }">
          <code>{{ item.remindable_type }}</code>
        </template>
        <template #item.remind_before_days="{ item }">
          {{ item.remind_before_days }} hari
        </template>
        <template #item.status="{ item }">
          <VChip
            size="small"
            :color="item.status === 'resolved' ? 'success' : 'warning'"
          >
            {{ item.status === 'resolved' ? 'Selesai' : 'Aktif' }}
          </VChip>
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Tidak ada reminder.
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
